
import { CARD_FIELD_NAMES } from "@constants";
import { required } from '../../../utils/validators';
import language from '@language';

const fieldsConfig = {
  fields: [
    {
      name: CARD_FIELD_NAMES.NAME,
      placeholder: language.cardPayment.name.placeholder,
      label: language.cardPayment.name.label,
    },
  ],
  validators: {
    [CARD_FIELD_NAMES.NAME]: [
      {
        fn: required,
        msg: language.cardPayment.name.required,
      },
    ],
  },
};

export default fieldsConfig;
